/** Добавить store-scope (`?stores=…`) к пути API — одинаково на сервере и в браузере. */
export function withDataScope(path: string, scopeQuery: string): string {
  if (!scopeQuery) return path;
  return path.includes("?") ? `${path}&${scopeQuery.slice(1)}` : `${path}${scopeQuery}`;
}
